import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Typography, SvgIcon } from "@material-ui/core";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";
import { FormattedMessage } from "react-intl";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import { styles } from "./constants/styles";
import messages from "./constants/messages";

type Props = WithStyles<typeof styles>;

const RegisterCompletePage: React.FC<Props> = (props: Props) => {
  const { classes } = props;
  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <SvgIcon fontSize={"large"} color={"primary"}>
          <CheckCircleOutline />
        </SvgIcon>
        <Typography className={classes.header}>
          <FormattedMessage {...messages.registerComplete} />
          &nbsp;
          <a href="mailto:ivan.zlatkovic@basf.com?subject=Registration Issue" className={classes.link}>
            <FormattedMessage {...messages.registerCompleteLinkMail} />
          </a>
        </Typography>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(RegisterCompletePage);
